<template>
    <projeto-resultados 
        :projeto-id="projetoIdBase" 
        :titulo="titulo" 
        :colunas="colunas" 
        :rubrica="rubrica" 
        :componente="componente" 
        :endpoint="endpoint" 
        @update="update"

        :chave-permissao="chavePermissao"
        :projeto-editavel="projetoEditavel"
    />
</template>
<script>
import helpers from "@/common/utils/helpers";
import ProjetoResultados from "../componentes/Resultados"
export default {
    components : {
        ProjetoResultados
    },
    props : ['projetoId', 'projetoIdBase', 'endpoint', 'chavePermissao', 'projetoEditavel'],
    data : () => ({
        colunas : [
            { key: 'tipo', label: "Indicador",
                formatter: (value) => {
                    if (value) return  helpers.getEnum(value).text;
                },
            },
            
            { key: "possibilidadeImpacto", label: "Possibilidade de impacto", },
            { key: "descricao", label: "Descrição do impacto", }
        ],
        componente : 'impacto-socioambiental',
        rubrica : 'impacto-socioambiental',
        titulo : 'Impactos Socioambientais',
    }),
    methods : {
        update : function(){
            this.$emit('update');
        }
    }
}
</script>
<style>
    
</style>